import { Button, createTheme, ThemeProvider } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { ABOUT_ROUTE, CONTACT_ROUTE, FAQS_ROUTE, HOME_ROUTE, PACKAGES_ROUTE } from "../../../routing/routing_constants"


export const SideBar = () => {
    const navigate = useNavigate()

    const theme = createTheme({
        palette:{
            custom:{
                main:"rgb(157, 131, 81)"
            }
        }
    })

    return (
        <div className='sidebar'>
            <div className='flex_column extra_nav_bar'>
                <div style={{width:"40%"}}>

                </div>
                <ThemeProvider theme={theme}>
                    <Button color="custom" onClick={e=>navigate(HOME_ROUTE)}>Home</Button>
                    <Button color="custom" onClick={(e)=>navigate(PACKAGES_ROUTE)}>
                        Tours & Adventures
                    </Button>
                    <Button color="custom" onClick={e=>navigate(ABOUT_ROUTE)}>
                        About Us
                    </Button>
                    <Button color="custom" onClick={e=>navigate(CONTACT_ROUTE)}>
                        Contact Us
                    </Button>
                    <Button color="custom" onClick={e=>navigate(FAQS_ROUTE)}>
                       FAQs
                    </Button>
                </ThemeProvider>
                
            </div>
        </div>
    )
}